import { render, staticRenderFns } from "./payCheck.vue?vue&type=template&id=572cc3ba"
import script from "./payCheck.vue?vue&type=script&lang=js"
export * from "./payCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports